export default __webpack_public_path__ + "static/media/footer.35245b4d.svg";